import { connect } from 'react-redux'
import ProductPricing from '../../../components/products/details/product/edit/pane/ProductPricing'
import * as actions from '../../../state/actions/provider-products/index'
import { IStoreState, IProviderProductObject } from '../../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    product: ownProps.product,
    pricing: ownProps.pricing,
    formRef: ownProps.formRef
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveProduct: (product: IProviderProductObject) => {
      return dispatch(actions.saveProduct(product))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPricing)



// WEBPACK FOOTER //
// ./src/containers/products/productedit/ProductPricing.ts